import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './pages/App.js';
import * as serviceWorker from './serviceWorker';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = require('./firebase-config.json');

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

if (process.env.REACT_APP_FIRESTORE_EMULATOR_HOST) {
  console.log(
    'Working against EMULATOR as defined in REACT_APP_FIRESTORE_EMULATOR_HOST=' +
      process.env.REACT_APP_FIRESTORE_EMULATOR_HOST,
  );
  firebase.firestore().settings({
    host: process.env.REACT_APP_FIRESTORE_EMULATOR_HOST,
    ssl: false,
  });
} else {
  firebase.firestore().enablePersistence({ synchronizeTabs: true });
}

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
